<div *ngIf="item">

  <add-configuration *ngIf="item.name == 'add'" [configurationId]="configurationId" (onAddClose)="closeDetailMenu($event)" ></add-configuration>
  <delete-configuration *ngIf="item.name == 'delete'" (onCancel)="closeDetailMenu($event)"></delete-configuration>
  <copy-configuration *ngIf="item.name == 'copy'" [configurationId]="configurationId" (onCancel)="closeDetailMenu($event)"></copy-configuration>
  <import-configuration *ngIf="item.name == 'import'" (onCancel)="closeDetailMenu($event)"></import-configuration>
  <sorting-configurations *ngIf="item.name == 'sort'" [parentConfId]="configurationId"></sorting-configurations>
  <!--Aritco-->
  <aritco-copy-conf *ngIf="item.name == 'aritco-copy'" [configurationId]="configurationId" (onClose)="closeDetailMenu($event)"></aritco-copy-conf>
  <!--End-->

</div>